module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/dialog-select-side/dialog-select-side.component.css
// module id = ./src/app/dialog-select-side/dialog-select-side.component.css
// module chunks = main